export class CustomError<
  Message extends string = string,
  Payload = unknown,
> extends Error {
  statusCode: number
  message: Message
  payload?: Payload

  constructor(
    statusCode: number,
    message: Message,
    payload?: Payload,
    name?: string,
  ) {
    super(message)
    this.statusCode = statusCode
    this.message = message
    this.payload = payload
    this.name = name || 'CustomError'
  }
}
